var account = "Conta";
var accountSettings = "Definições da conta";
var charging = "Carregamento";
var contactInfo = "Informações de contacto";
var dashboard = "Painel de controlo";
var home = "Ecrã inicial";
var myProducts = "Os Meus Produtos";
var orderHistory = "Histórico de encomendas";
var paymentMethod = "Método de pagamento";
var profileSettings = "Definições de Perfil";
var referAndEarn = "Referencie e ganhe";
var signOut = "Terminar sessão";
var pt_PT = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, pt_PT as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
